import { FormItem } from "./FormItem";
import React, { useMemo, useRef, useState } from "react";
import {
  DateRange,
  DateRangePicker as MUIDateRangePicker,
  LocalizationProvider as LocalizationProviderPro,
} from "@mui/x-date-pickers-pro";

import { Stack, TextField } from "@mui/material";
import { asKey } from "./asKey";
import { DateTime } from "luxon";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import {
  isAmpmTimezone,
  getDateOrderForTimezone,
  getDateFormatString,
} from "../src/utils/dateTimeUtils";

interface IDatePickerProps {
  date: DateTime;
  setDate: Function;
  label: string;
  name: string;
  maxDateTime?: DateTime;
  minDateTime?: DateTime;
  disabled?: boolean;
  ampm?: boolean;
  timezone?: string;
  format?: string;
}

interface DateRangePickerProps {
  dateRange: DateRange<DateTime>;
  setDateRange: Function;
  label: string;
  name: string;
}

function DateRangePicker(props: DateRangePickerProps) {
  const { dateRange, setDateRange, label } = props;
  // console.log(dateRange)
  return (
    <LocalizationProviderPro dateAdapter={AdapterLuxon}>
      <MUIDateRangePicker
        value={dateRange}
        onChange={(newRange) => {
          console.log(newRange);
          setDateRange(newRange);
        }}
        label={label}
        disableFuture={false}
        disableMaskedInput
        mask="____/__/__"
        inputFormat={"yyyy-MM-dd"}
        renderInput={(startProps, endProps) => (
          <Stack spacing={2}>
            <TextField {...startProps} size="small" />
            <TextField {...endProps} size="small" />
          </Stack>
        )}
      />
    </LocalizationProviderPro>
  );
}

export function DateTimePicker(props: IDatePickerProps) {
  const { date, setDate, label, maxDateTime, minDateTime, timezone } = props;
  const [open, setOpen] = useState(false);

  const useAmPm = isAmpmTimezone(timezone || "UTC");

  // Format for input field (without seconds)
  const inputFormat =
    getDateFormatString(getDateOrderForTimezone(timezone || "UTC")) +
    (useAmPm ? " hh:mm a" : " HH:mm"); // Removed seconds

  // Format for other displays (with seconds) - passed via props if needed
  const fullFormat =
    getDateFormatString(getDateOrderForTimezone(timezone || "UTC")) +
    (useAmPm ? " hh:mm:ss a" : " HH:mm:ss");

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DesktopDateTimePicker
        value={date}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(newDate) => {
          // @ts-ignore
          setDate(newDate);
        }}
        label={label}
        inputFormat={inputFormat} // Uses format without seconds
        mask={inputFormat.replace(/[a-zA-Z]/g, "_")}
        disableFuture={false}
        ampm={useAmPm}
        ampmInClock={useAmPm}
        maxDateTime={maxDateTime}
        minDateTime={minDateTime}
        renderInput={(props) => (
          <TextField
            onClick={() => setOpen(true)}
            name={props.name}
            size="small"
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
}

export function DateRangeInput(props: {
  name: string;
  range: DateRange<DateTime>;
  label?: string;
  setRange: React.Dispatch<React.SetStateAction<DateRange<DateTime>>>;
}) {
  const key = asKey(props.name);
  return (
    <FormItem>
      {/*<label style={{alignSelf: "center"}}>{props.label ?? props.name}: </label>*/}
      {/* @ts-ignore */}
      <DateRangePicker
        key={key}
        name={key}
        dateRange={props.range}
        setDateRange={props.setRange}
        label={props.label ?? props.name}
      />
      {/*<input readOnly required hidden name={key} value={props.date.toISO()}/>*/}
    </FormItem>
  );
}

export function DateInput(props: {
  name: string;
  date: DateTime;
  label?: string;
  setDate: (value: ((prevState: DateTime) => DateTime) | DateTime) => void;
}) {
  const key = asKey(props.name);
  return (
    <FormItem>
      {/*<label style={{alignSelf: "center"}}>{props.label ?? props.name}: </label>*/}
      {/* @ts-ignore */}
      <DateTimePicker
        key={key}
        name={key}
        date={props.date}
        setDate={props.setDate}
        label={props.label ?? props.name}
      />
      {/*<input readOnly required hidden name={key} value={props.date.toISO()}/>*/}
      <input
        readOnly
        required
        hidden
        name={"timezone"}
        value={props.date.zoneName}
      />
    </FormItem>
  );
}
